import { render, staticRenderFns } from "./MailingList.vue?vue&type=template&id=753697d8&scoped=true"
import script from "./MailingList.vue?vue&type=script&lang=js"
export * from "./MailingList.vue?vue&type=script&lang=js"
import style0 from "./MailingList.vue?vue&type=style&index=0&id=753697d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753697d8",
  null
  
)

export default component.exports